import { useAppSelector } from 'app/hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  clearMessage,
  hideError,
  selectDataErrorResponse,
  selectMessagesResponse,
} from '../ErrorNotification/errorNotificationSlice';
import { CustomToast, ToastSample } from '../Toast/models/toast';
import ToastComponent from '../Toast/page';

const UseToastComponent: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const resMessagesSelector = useAppSelector(selectMessagesResponse);
  const resErrorSelector = useAppSelector(selectDataErrorResponse);
  const [toastList, setToastList] = useState<Array<CustomToast>>([]);

  useEffect(() => {
    if (resMessagesSelector) {
      const toast =
        resMessagesSelector.status === 'success'
          ? ToastSample.toastSuccess(t('App.success'), resMessagesSelector.message)
          : ToastSample.toastError(t('App.error'), resMessagesSelector.message);

      setToastList((prevList) => [...prevList, toast]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resMessagesSelector]);

  useEffect(() => {
    if (resErrorSelector) {
      const toast = ToastSample.toastError(t('App.error'), resErrorSelector.message);
      setToastList((prevList) => [...prevList, toast]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resErrorSelector]);

  // Cleanup function to dispatch actions and clear toastList when the component unmounts
  useEffect(
    () => () => {
      dispatch(clearMessage());
      dispatch(hideError());
      setToastList([]);
    },
    [dispatch]
  );

  return (
    <>
      {toastList.length > 0 && (
        <ToastComponent toastList={toastList} position={'bottom-end'} autoDelete={true} autoDeleteTime={2500} />
      )}
    </>
  );
};

export default UseToastComponent;
